var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pill",class:_vm.pillClass},[_c('span',{staticClass:"dot"}),_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }